import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { VoiceConversationTopicPill } from "../VoiceConversationTopicPill";
import { ReactComponent as CornerIcon } from "./assets/corner.svg";
import { ReactComponent as SparkleIcon } from "./assets/sparkle.svg";

export const VoiceConversationSummaryCard: React.FC<{
  topic: string;
  summary: string;
}> = ({ topic, summary }) => {
  const { t } = useTranslations();

  return (
    <div className="relative w-full overflow-hidden rounded-lg border-0 border-l-3 border-solid border-[#E8E2F8] bg-white p-3.5">
      <CornerIcon className="pointer-events-none absolute top-0 right-0" />
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1.5">
          <div className="flex items-center gap-1.5">
            <SparkleIcon className="shrink-0" />
            <span className="font-secondary text-sm font-medium text-dark">
              {t({
                id: "client-support-page.voice-summary-label",
                defaultMessage: "Summary:",
              })}
            </span>
          </div>
          <span className="font-secondary text-[13px] text-dark-700">
            {summary}
          </span>
        </div>
        <VoiceConversationTopicPill topic={topic} disableTooltip />
      </div>
    </div>
  );
};
